export default function getAccountNumber(state) {
  let accountNumber = "";
  if (state.loginForm && state.loginForm.accountNumber) {
    accountNumber = state.loginForm.accountNumber.trim();
  }
  return accountNumber;
}